import { render, staticRenderFns } from "./ssq.vue?vue&type=template&id=988d0382&scoped=true"
import script from "./ssq.vue?vue&type=script&lang=js"
export * from "./ssq.vue?vue&type=script&lang=js"
import style0 from "./ssq.vue?vue&type=style&index=0&id=988d0382&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988d0382",
  null
  
)

export default component.exports